import { useCallback, useEffect, useRef, useState } from "react";
import { getRecentNotifications } from "@/services/api/notifications";

export function useRecentNotifications({
  enabled = true,
  pageSize = 10,
  refreshKey = "",
} = {}) {
  const [items, setItems] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const requestRef = useRef(0);

  const refresh = useCallback(async () => {
    if (!enabled) return;

    const requestId = requestRef.current + 1;
    requestRef.current = requestId;
    setLoading(true);
    setError(null);

    try {
      const result = await getRecentNotifications({
        page: 1,
        pageSize,
        status: 0,
        hours: 24
      });

      if (requestRef.current !== requestId) return;

      setItems(result.items);
      setUnreadCount(result.unreadCount);
    } catch (err) {
      if (requestRef.current !== requestId) return;
      setError(err);
      setItems([]);
      setUnreadCount(0);
    } finally {
      if (requestRef.current === requestId) {
        setLoading(false);
      }
    }
  }, [enabled, pageSize]);

  useEffect(() => {
    if (!enabled) return undefined;
    refresh();
    return undefined;
  }, [enabled, refresh, refreshKey]);

  return {
    items,
    unreadCount,
    loading,
    error,
    refresh,
  };
}
